import RedemptionTable from './redemptionTable.container';

export default RedemptionTable